/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * this class is invoked from render sequence for rendering crosshair step.
 * The dependency for this step is render step. 
 */
class RenderCrosshairStep {
	constructor(options, moduleOptions) {
		this.crosshairFeature = moduleOptions.visCrosshairFeature;
		this.id = options.id;
		this.owner = options.owner;
		this.visAPI = options.visAPI;

		this._initializeStep = this.owner._initializeStep.bind(this.owner);
		this._isStepComplete = this.owner._isStepComplete.bind(this.owner);
		this._completeStep = this.owner._completeStep.bind(this.owner);
		this._logRenderContext = this.owner._logRenderContext.bind(this.owner);

		if (this.id) {
			this._initializeStep(this.id);
		}
	}

	getRenderState() {
		return this.owner._renderState;
	}

	clearError() {
		this.visAPI.visHelper.clearError();
	}

	showError(msg, params) {
		this.visAPI.visHelper.showError(msg, params);
	}

	process(renderContext) {
		if (this._isStepComplete(renderContext, 'renderVisCrosshairs')) {
			return Promise.resolve(renderContext);
		}
		// Render is complete. Update the vis crosshairs decorations if the feature is activated
		if(this.crosshairFeature.isActivated()){
			this.crosshairFeature.renderCrosshairs(/*value*/);
		}
		return Promise.resolve(true);
	}

}

export default RenderCrosshairStep;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-crosshairs/src/js/RenderCrosshairsStep.js